
<template>
  <div class="map-list-main-page">
    <main-header :hasBanner="true" :type="'wqdd'"></main-header>
    <section class="main-center list-clr">
      <div class="map-title">网签地点分布</div>
      <div class="right-top">
        <el-select
          class="ad-select"
          v-model="searchObj.districtId"
          @change="search"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          @keyup.enter.native="search"
          class="ad-input"
          v-model="searchObj.name"
          placeholder="请输入名称"
          type="text"
        />
        <div class="search-btn" @click="search">查&nbsp;&nbsp;询</div>
      </div>

      <div id="mapBox"></div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import { districtList } from "@/assets/api/common";
import { companyAndStore, companyList } from "@/assets/api/company";

export default {
  name: "creditList",
  components: {
    mainHeader,
    mainFooter,
  },

  data() {
    return {
      map: null,
      options: [],
      searchObj: {
        districtId: "",
        name: "",
        pageNum: 1,
        pageSize: 100
      },
    };
  },
  computed: {},
  mounted() {
    this.initCity();
    this.initMap();
  },
  methods: {
    async initCity() {
      const res = await districtList();
      this.options = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
    },
    search() {
      this.getData();
    },
    async getData() {
      this.map.clearOverlays()
      const res = await companyAndStore(this.searchObj);
      
      if (res && res.data && res.data.code == 200) {
        // this.tableData = res.data.rows || [];
        // this.tableData = this.tableData.map((item) => {
        //   return {
        //     ...item,
        //     mobileUrl: `${this.$globalData.serverUrl}/#/mCompanyDetail?id=${item.id}`,
        //   };
        // });
        // this.total = res.data.total;
        let list =  res.data.rows || [];
        list = list.map(item=> {
          return {
            title: item.name,
            message: item.address,
            Longitude: item.lng,
            latitude: item.lat,
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
          }
        })
   
        let info = list.map((item) => {
          return {
            ...item,
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
          };
        });
        this.map.panTo(new BMapGL.Point(info[0].Longitude, info[0].latitude))
        info.forEach((item) => {
          // 创建点坐标
          let point = new BMapGL.Point(item.Longitude, item.latitude);
          let marker = new BMapGL.Marker(point); // 创建标注
          this.map.addOverlay(marker); // 将标注添加到地图中
          var infoWindow = new BMapGL.InfoWindow(item.message, item); // 创建信息窗口对象
          this.map.openInfoWindow(infoWindow, point); //开启信息窗口
          marker.addEventListener("onmouseover", function () {
            this.map.openInfoWindow(infoWindow, point); //开启信息窗口
          });
        });
      }
    },
    initMap() {
      this.map = new BMapGL.Map("mapBox");
      // 创建地图实例
      var point = new BMapGL.Point(115.97, 36.45);
      this.map.centerAndZoom(point, 13);
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      this.getData();
    },
  },
};
</script>

<style lang="less">
.map-list-main-page {
  background: #fff;
  .list-clr {
    .map-title {
      padding: 10px 0;
      font-size: 18px;
      color: #222;
    }
    #mapBox {
      width: 100%;
      height: 1000px;
      margin-bottom: 20px;
    }
  }
  .mg-t20 {
    margin-top: 20px;
  }

  .el-table .cell {
    overflow: initial !important;
  }
  .el-table {
    overflow: initial !important;
  }
  .el-table__body-wrapper {
    overflow: initial !important;
  }
  .qr-box {
    position: relative;
    z-index: 2;
    img {
      position: absolute;
      z-index: 1;
      left: -50px;
      top: 10px;
    }
  }
  .bottom-pagination {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
  }

  .select-box {
    margin: 0 0 20px 0;
    display: flex;
    justify-content: flex-end;
  }

  .right-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    .ad-select {
      width: 203px;
      input {
        height: 50px;
        border-radius: 0;
      }
    }
    .ad-input {
      flex: 1;
      height: 50px;
      border: 1px solid #dcdfe6;
      border-left: 0;
      border-right: 0;
      input {
        height: 100%;
        border: none;
      }
    }
    .search-btn {
      background: #9b2f3d;
      width: 140px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      cursor: pointer;
    }
  }

   .BMap_bubble_title {
    width: 180px!important;
     white-space: nowrap!important;
    text-overflow: ellipsis!important;
    overflow: hidden!important;
    word-break: break-all!important;
  }
}
</style>